// @ts-nocheck

import React, {Component} from 'react'
import DockButton from './DockButton.js'
import {Droppable, Draggable, DragDropContext } from "react-beautiful-dnd"
const navigationButtonsIds = require('../Navigation/navigationButtonsIds.js');
const designerConstants = require('./constants.js');


class DockBarView extends Component 
{
    render()
    {
        let buttonIds = this.props.context.dockBar;
        var components = [];

        for (let index = 0; index < designerConstants.maximumNoOfDockBarButtons; index++)
        {
            let button = index < buttonIds.length ? buttonIds[index] : navigationButtonsIds.blank;

            let marginLeft = index == 0 ? 'auto' : '10px';
            let marginRight = (index+1 == designerConstants.maximumNoOfDockBarButtons) ? "auto": "0px";

            let onDeleteButton = ()=>{this.props.onDelete(index, designerConstants.dockBarDroppableId)}
            let onAddButton = ()=>{this.props.onAdd(designerConstants.dockBarDroppableId)}

            components.push(this.createDockBarButton(index, button, onDeleteButton, onAddButton, marginLeft, marginRight));
        }

        return <DragDropContext key="layout.designer.dockbar.drag.drop.context" onDragEnd={this.props.onDragEnd}>
                    <Droppable key={designerConstants.dockBarDroppableId} droppableId={designerConstants.dockBarDroppableId} direction="horizontal">
                            {(provided, snapshot) => (
                                                    <div ref={provided.innerRef} className="d-flex justify-content-center" style={{overflowX:'auto', width:Math.round(window.innerWidth * 0.99)}}>
                                                        {components}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                    </Droppable>
                </DragDropContext>
                
    }

    createDockBarButton(index, button, onDelete, onAdd, marginLeft, marginRight)
    {
        return <Draggable key={`dockButton.${index}.key`} draggableId={`dockButton.${index}.id`} index={index}>
                                    {(provided, snapshot) => (
                                        <div ref={provided.innerRef} {...provided.draggableProps}{...provided.dragHandleProps}>
                                                <DockButton onDelete={onDelete} onAdd={onAdd} onClick={()=>{}} button={button} marginLeft={marginLeft} marginRight={marginRight}/>
                                        </div>
                                    )}
                    </Draggable>
    }

    onDragEnd(result)
    {
    }

    onDeleteButton(index)
    {
        alert("Button To Be Deleted " + index);
    }

    onAddButton(index)
    {
        alert("Button To Be Added " + index);
    }
}

export default DockBarView
